import React, { useEffect, useRef, useState, useCallback } from 'react';
import KUTE from 'kute.js';
import { useParticipantIds, useActiveParticipant } from '@daily-co/daily-react';
import { pageAtom, isAuthAtom, nftIDAtom, nftDetailAtom } from '../../State';
import { useRecoilState, useRecoilValue } from 'recoil';
import { ReactComponent as CloseSVG } from '../Images/buttons/closeBlackButton.svg';
import { ReactComponent as DiscordSVG } from '../Images/buttons/discord.svg';
import { ReactComponent as OpenseaSVG } from '../Images/buttons/opensealogo.svg';
import { ReactComponent as TwitterSVG } from '../Images/buttons/twitter.svg';
import { ReactComponent as WebsiteSVG } from '../Images/buttons/websiteButton.svg';
import { ReactComponent as RightArrowSVG } from '../Images/buttons/rightArrow.svg';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useTranslation } from 'react-i18next';
import { getImagePath } from '../Util/utils';
import DataModel from '../Util/DataModel';
import AddAccess from '../Util/AddAccess';
import FaceImage from '../Setting/FaceImage';

export default function NFTDetail() {
  //Recoil系
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [nftDetailPageState, setNftDetailPageState] = useRecoilState(nftDetailAtom);
  const nftIDValue = useRecoilValue(nftIDAtom);
  const [nameState, setNameState] = useState(null);
  const [imageState, setImageState] = useState(null);
  const [aboutMeState, setAboutMeState] = useState(null);
  const [isAuthState, setAuthState] = useRecoilState(isAuthAtom);

  //その他
  const [nftDetailState, setNftDetailState] = useState(null);
  const [loadState, setLoadState] = useState(false);
  const { t } = useTranslation();

  //詳細リンクについて
  var external_url = '';
  if (nftDetailState != null) {
    if (nftDetailState.nftDetailURL != null) {
      external_url = nftDetailState.nftDetailURL;
    } else if (nftDetailState.collectionURL) {
      external_url = nftDetailState.collectionURL;
    }
  }

  //初回ロード時
  useEffect(() => {
    if (nftDetailPageState.show) {
      //アニメーション
      startAnimation();

      if (nftDetailPageState.isMe) {
        if (localStorage.getItem('displayName') != null) {
          setNameState(localStorage.getItem('displayName'));
        }
      } else if (nftDetailPageState.displayName != null) {
        setNameState(nftDetailPageState.displayName);
      }

      //ユーザー情報
      getUserInfo();

      //NFT詳細を取得
      getNFTDetail();

      //アクセス
      AddAccess('page-view', 'nftDetail', nftDetailPageState.nftID);
    }
  }, [nftDetailPageState]);

  function startAnimation() {
    var anim1 = KUTE.to(
      '#nftDetailWrap2',
      { scale: 1 },
      { duration: 200, easing: 'easingSinusoidalIn' },
    ).start();

    var anim1 = KUTE.to(
      '#backWrap',
      // { opacity: 0 },
      { opacity: 1 },
      { duration: 200, easing: 'easingSinusoidalIn' },
    ).start();
  }

  //ユーザー情報取得
  const getUserInfo = async () => {
    const userData = await DataModel.getSpecificUserData(
      'aboutme',
      nftDetailPageState.userID,
      nftDetailPageState.isMe,
    );

    console.log(userData);

    if (userData != null) {
      if (userData.aboutme != null) {
        setAboutMeState(userData.aboutme);
      }
    }
  };

  //NFT詳細を取得
  const getNFTDetail = async () => {
    //カスタムアバターの場合
    if (nftDetailPageState.nftID.startsWith('custom')) {
      //setImageState(nftDetailPageState.nftID);
    }
    //NFTアバターの場合
    else {
      const nftDetail = await DataModel.getNFTDetail(nftDetailPageState.nftID);

      if (nftDetail != null) {
        setNftDetailState(nftDetail);
      }
    }
  };

  //背景をタップ時
  const tapBack = () => {
    resetState();
  };

  //リセットする
  function resetState() {
    setNftDetailPageState({
      show: false,
      isMe: false,
      displayName: null,
      userID: null,
      nftID: null,
      nftWhoCanUse: 'anyone',
    });
    setNameState(null);
    setNftDetailState(null);
    setAboutMeState(null);
  }

  //ロード完了
  const loadImageComplete = () => {
    setLoadState(true);
  };

  //ロード完了
  const tapLink = () => {
    if (external_url != '') {
      window.open(external_url, '_blank');
    }
  };
  const URL_REGEX =
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

  const renderText = (txt) =>
    txt.split(' ').map((part) =>
      URL_REGEX.test(part) ? (
        <a target="_blank" href={part}>
          {part}{' '}
        </a>
      ) : (
        part + ' '
      ),
    );

  const NFTScreen = () => {
    return (
      <div id="nftDetailGridWrap">
        <div id="nftDetailLeft">
          <div id="nftDetailLeftImage">
            <FaceImage myNftState={nftDetailPageState.nftID} />
            {/* {!loadState && nftDetailState.videoURL == null && (
              <Skeleton
                circle={true}
                baseColor={'#ccc'}
                highlightColor={'#fff'}
                width={'100%'}
                height={'100%'}
              />
            )}

            {nftDetailState.videoURL != null ? (
              <video
                src={nftDetailState.videoURL}
                autoPlay
                muted
                loop
                playsInline
                onLoad={loadImageComplete}
                poster={nftDetailState.imageURL}></video>
            ) : (
              <>
                {nftDetailState.imageURL != null && (
                  <>
                    <img
                      src={nftDetailState.imageURL}
                      onLoad={loadImageComplete}
                      style={{ display: loadState ? 'block' : 'none' }}
                    />
                  </>
                )}
              </>
            )} */}
          </div>
        </div>

        <div id="nftDetailCenter">
          <div className="detailHead">Basic</div>
          <div className="detailName">{nameState != null ? nameState : '---'}</div>
          {aboutMeState != null && <div className="detailAboutme">{renderText(aboutMeState)}</div>}
        </div>

        {nftDetailState != null && (
          <div id="nftDetailRight">
            <div className="nftImage">
              {nftDetailState.collectionImageURL != null && (
                <img src={nftDetailState.collectionImageURL} />
              )}
            </div>

            <div className="nftRight" onClick={tapLink}>
              {nftDetailState.name != null && <div id="nftDetailName">{nftDetailState.name}</div>}
              <div id="nftDetailDetail">
                {nftDetailState.description != null ? nftDetailState.description : 'NFT Avatar'}
              </div>
            </div>
            <div className="nftArrow">
              <RightArrowSVG />
            </div>
          </div>
        )}

        <button className="nftDetailCloseButton" onClick={tapBack}>
          {t('setting.Close')}
        </button>
      </div>
    );
  };

  //レンダービュー
  const renderScreen = () => {
    return (
      <>
        <div id="backWrap" onClick={tapBack} style={{ opacity: '0' }}></div>

        <div id="nftDetailFlex">
          <div id="nftDetailWrap2" style={{ transform: 'scale(0,0)' }}>
            <div id="nftTitle">
              {/* <div id="nftCloseButton">
                <CloseSVG onClick={tapBack} />
              </div> */}
            </div>
            <NFTScreen />
          </div>
        </div>
      </>
    );
  };

  return nftDetailPageState.show && renderScreen();
}
